import React, {memo} from 'react';
import {INav} from 'features/layout/redux/helpers/FoldersHelper';
import {useTranslation} from 'react-i18next';
import api from 'api';
import {folderTypes} from 'redux/folders';
import {ConfirmationDialog} from 'components/dialogs/ConfirmationDialog';
import {useDeleteApiDispatch} from 'common/hooks/useDeleteApiDispatch';
import {DialogTypes} from 'common/names';

interface Props {
   onClose: () => void;
   data: INav;
}
const FolderDeleteDialog = memo(({data, onClose}: Props) => {
   const {t} = useTranslation();
   const deleteFolder = useDeleteApiDispatch(
      `${api.folders}/${data.id}`,
      folderTypes.DELETE_SUB_FOLDER
   );

   if (data.immutable) {
      return null;
   }

   return (
      <>
         <ConfirmationDialog
            content={t(`Do you want to delete Folder ${data.name}`)}
            title={DialogTypes.FolderDeleteDialog.dialogName}
            onOk={() => {
               deleteFolder();
               onClose();
            }}
            onCancel={onClose}
         />
      </>
   );
});

export default FolderDeleteDialog;
